import { Button, Card, Flex, Icon, Text } from "@engaging-tech/components"
import { Link } from "@engaging-tech/routing"
import { getConfig } from "@engaging-tech/ssr-config"
import React from "react"
import styled from "styled-components"

const StyledLockedCard = styled(Card)`
  position: absolute;
  transform: translate(40%, -50%);
  width: 30rem;
  height: 188px;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints[1]}px) {
    transform: translate(25%, -50%);
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints[0]}px) {
    transform: translate(0%, 200%);
    height: 183px;
  }

  @media only screen and (max-width: 480px) {
    transform: translate(0%, 175%);
    width: calc(100% - 2rem);
  }
`

export default function LockedCard() {
  return (
    <StyledLockedCard bg="primary.0" flexDirection="column" justifyContent="center" alignItems="center">
      <Icon pb={2} name="lock" color="white" size="44" />
      <Flex flexDirection="column" py={1} mb={2}>
        <Text textAlign="center" color="white" fontWeight={700}>
          Business owner or leader?
        </Text>
        <Text textAlign="center" color="white">
          Register to find out more
        </Text>
      </Flex>
      <Link to={`${getConfig().worklForBusiness.public.index}/data-insights/`} external newTab>
        <Button my={2} height="32px">
          <Icon pr={1} name="lock" color="primary.0" size="20" />
          <Text color="primary.0">UNLOCK INSIGHTS</Text>
        </Button>
      </Link>
    </StyledLockedCard>
  )
}
